import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Modal from '../../Common/Modals/Modal';
import { ArrowInCircle } from '../../Common/Svg/Icons';

import { mobileMediaQuery } from '../../Theming';

const StyledModal = styled(Modal)`
  max-width: 500px;
  padding-bottom: 0;

  ${mobileMediaQuery} {
    max-width: 100%;
    padding-right: 20px;
    padding-left: 20px;
  }
`;

const Heading = styled.h1`
  justify-content: space-between;
  font-size: 2.5rem;
  line-height: 2.75rem;
  margin: 0;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: scroll;
  padding-bottom: 70px;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

type DescriptionModalProps = {
  show: boolean;
  onHide(): void;
};
const StyledHeadingArrowInCircle = styled(ArrowInCircle)`
  margin-left: 18px;
`;
const P = styled.p`
  font-size: 1rem;
`;
const DescriptionModal: React.FC<DescriptionModalProps> = ({
  show,
  onHide,
}) => {
  const { t } = useTranslation();
  return (
    <StyledModal isOpen={show} onClose={onHide}>
      <Container>
        <Heading>
          {t('keyboardInstallationGuide.whatisfullaccess')}
          <StyledHeadingArrowInCircle />
        </Heading>

        <P>{t('keyboardInstallationGuide.whatisfullaccessdescription')}</P>
      </Container>
    </StyledModal>
  );
};
export default DescriptionModal;
